// ServiceGroupService.tsx
import { BaseService } from '../../core/BaseService';
import { ChangeStatusRequest, PaginationParams } from '../../type';
import {
  AssignUnassignAllRequest,
  AssignUnassignAllResponse,
  AssignUnassignResponse,
  AssignUnassignServiceRequest,
  AssignUnassignTechnicianRequest,
  ChangeStatusServiceGroupResponse,
  DeleteServiceGroupResponse,
  GetServiceGroupByIdResponse,
  GetServiceGroupResponse,
  GetServiceGroupServiceResponse,
  GetServiceGroupTechnicianResponse,
  ServiceGroupRequest,
  ServiceGroupResponse,
} from './interface';

export class ServiceGroupProfile extends BaseService {
  async createServiceGroup(req: ServiceGroupRequest) {
    const headers = { 'Content-Type': 'multipart/form-data' };

    const formData = new FormData();

    Object.entries(req).forEach(([key, value]) => {
      if (value !== null) {
        formData.append(key, value);
      }
    });

    return this.post<ServiceGroupResponse, FormData>(`${this.apiUrl}/api/servicegroups`, formData, { headers });
  }

  async getServiceGroup(params: PaginationParams) {
    return this.get<GetServiceGroupResponse>(`${this.apiUrl}/api/servicegroups/paged`, params);
  }

  async getServiceGroupDropdown(params: PaginationParams) {
    return this.get<GetServiceGroupResponse>(`${this.apiUrl}/api/servicegroups/get`, params);
  }

  async updateServiceGroup(req: ServiceGroupRequest) {
    const headers = { 'Content-Type': 'multipart/form-data' };

    const formData = new FormData();

    Object.entries(req).forEach(([key, value]) => {
      if (value !== null) {
        formData.append(key, value);
      }
    });

    return this.put<ServiceGroupResponse, FormData>(`${this.apiUrl}/api/servicegroups/update`, formData, { headers });
  }

  async deleteServiceGroup(id: number) {
    return this.delete<DeleteServiceGroupResponse>(`${this.apiUrl}/api/servicegroups/${id}`);
  }

  async changeStatusServiceGroup(id: number, active: string, req: ChangeStatusRequest) {
    return this.put<ChangeStatusServiceGroupResponse, ChangeStatusRequest>(
      `${this.apiUrl}/api/servicegroups/${active}/${id}`,
      req
    );
  }

  async getServiceGroupService(params: PaginationParams & { serviceGroupId: number }) {
    return this.get<GetServiceGroupServiceResponse>(`${this.apiUrl}/api/services/byservicegroupid`, params);
  }

  async assignService(req: AssignUnassignServiceRequest) {
    return this.post<AssignUnassignResponse, AssignUnassignServiceRequest>(
      `${this.apiUrl}/api/servicegroups/service/assign`,
      req
    );
  }

  async unassignService(req: AssignUnassignServiceRequest) {
    return this.put<AssignUnassignResponse, AssignUnassignServiceRequest>(
      `${this.apiUrl}/api/servicegroups/service/unassign`,
      req
    );
  }

  async assignAllServices(req: AssignUnassignAllRequest) {
    return this.post<AssignUnassignAllResponse, AssignUnassignAllRequest>(
      `${this.apiUrl}/api/servicegroups/service/assignall`,
      req
    );
  }

  async unassignAllServices(req: AssignUnassignAllRequest) {
    return this.put<AssignUnassignAllResponse, AssignUnassignAllRequest>(
      `${this.apiUrl}/api/servicegroups/service/unassignall`,
      req
    );
  }

  async getServiceGroupById(id: number | undefined) {
    return this.get<GetServiceGroupByIdResponse>(`${this.apiUrl}/api/servicegroups/${id}`);
  }

  async getServiceGroupTechnician(params: PaginationParams & { serviceGroupId: number }) {
    return this.get<GetServiceGroupTechnicianResponse>(`${this.apiUrl}/api/servicegroups/gettechnician`, params);
  }

  async assignTechnician(req: AssignUnassignTechnicianRequest) {
    return this.post<AssignUnassignResponse, AssignUnassignTechnicianRequest>(
      `${this.apiUrl}/api/servicegroups/technician/assign`,
      req
    );
  }

  async unassignTechnician(req: AssignUnassignTechnicianRequest) {
    return this.put<AssignUnassignResponse, AssignUnassignTechnicianRequest>(
      `${this.apiUrl}/api/servicegroups/technician/unassign`,
      req
    );
  }

  async assignAllTechnicians(req: AssignUnassignAllRequest) {
    return this.post<AssignUnassignAllResponse, AssignUnassignAllRequest>(
      `${this.apiUrl}/api/servicegroups/technician/assignall`,
      req
    );
  }

  async unassignAllTechnicians(req: AssignUnassignAllRequest) {
    return this.put<AssignUnassignAllResponse, AssignUnassignAllRequest>(
      `${this.apiUrl}/api/servicegroups/technician/unassignall`,
      req
    );
  }
}
